// Mock data for J K Chems grocery store

export const categories = [
  {
    id: 1,
    title: "Grocery Home Delivery",
    description: "Complete range of daily grocery items including rice, dal, flour, oil, and more delivered to your doorstep.",
    icon: "ShoppingBasket",
  },
  {
    id: 2,
    title: "Milk & Dairy",
    description: "Fresh milk, curd, paneer, butter, cheese, and other dairy products from trusted brands.",
    icon: "Milk",
  },
  {
    id: 3,
    title: "Health Foods",
    description: "Nutritious health foods including quinoa, chia seeds, flax seeds, oats, and wholesome organic products for a healthier lifestyle.",
    icon: "Heart",
  },
  {
    id: 4,
    title: "Diabetes Friendly Foods",
    description: "Special diabetic-friendly products including millets, sugar-free items, protein bars, low-GI foods, and health supplements.",
    icon: "Activity",
  },
  {
    id: 5,
    title: "Spices & Masalas",
    description: "Authentic Indian spices, masalas, and condiments to add flavor to your cooking.",
    icon: "Flame",
  },
  {
    id: 6,
    title: "Dry Fruits & Snacks",
    description: "Premium quality dry fruits, nuts, and packaged snacks for healthy munching.",
    icon: "Nut",
  },
  {
    id: 7,
    title: "Frozen Food & Ice",
    description: "Frozen vegetables, ready-to-eat meals, and ice cubes for your convenience.",
    icon: "Snowflake",
  },
];

export const usps = [
  {
    id: 1,
    title: "4.5+ Rating",
    description: "Trusted by hundreds of happy customers",
    icon: "Star",
  },
  {
    id: 2,
    title: "Same-Day Delivery",
    description: "Order before noon, get it the same day",
    icon: "Truck",
  },
  {
    id: 3,
    title: "Bulk Discounts",
    description: "Special pricing for bulk and regular orders",
    icon: "BadgePercent",
  },
  {
    id: 4,
    title: "No Delivery Charges",
    description: "Free delivery on minimum order value",
    icon: "IndianRupee",
  },
];

export const howItWorks = [
  {
    step: 1,
    title: "Send Your List",
    description: "WhatsApp or call us with your grocery requirements",
    icon: "MessageSquare",
  },
  {
    step: 2,
    title: "Get Confirmation",
    description: "We confirm availability and share the total amount",
    icon: "CheckCircle",
  },
  {
    step: 3,
    title: "Same-Day Delivery",
    description: "Receive fresh groceries at your doorstep",
    icon: "Package",
  },
];

export const storeInfo = {
  name: "J K Chems",
  phone: "8770323650",
  phone2: "8461829294",
  phone3: "9425412118",
  landline1: "0761 2400495",
  landline2: "0761 4074272",
  email: "aniljaggi52@gmail.com",
  address: {
    line1: "Nehru Railway Colony, Katanga",
    line2: "Gorakhpur Main Road",
    city: "Jabalpur",
    state: "Madhya Pradesh",
    pincode: "482001",
  },
  location: "Gorakhpur, Jabalpur",
  serviceArea: "Serving all near by areas from gorakhpur",
  rating: 4.5,
  yearStarted: 2018,
  mapLink: "https://www.google.com/maps/place/J+K+Chems/@23.1519049,79.932537,17z/data=!3m1!4b1!4m6!3m5!1s0x3981ade233a1c95f:0x68b2bea406a8328f!8m2!3d23.1519!4d79.9351119!16s%2Fg%2F119tzrtqh?entry=ttu&g_ep=EgoyMDI2MDIxMS4wIKXMDSoASAFQAw%3D%3D",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3667.0736747856547!2d79.93253697532367!3d23.151904979103652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981ade233a1c95f%3A0x68b2bea406a8328f!2sJ%20K%20Chems!5e0!3m2!1sen!2sin!4v1708077894735!5m2!1sen!2sin",
  mapCoordinates: {
    lat: 23.1519,
    lng: 79.9351119,
  },
};

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    area: "Gorakhpur",
    rating: 5,
    text: "Best grocery delivery service in the area! Always on time and fresh products.",
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    area: "Katanga",
    rating: 5,
    text: "Using their service for 2 years now. Very reliable for bulk orders and monthly supplies.",
  },
  {
    id: 3,
    name: "Sunita Verma",
    area: "Railway Colony",
    rating: 4,
    text: "Great service and good quality products. The delivery is always prompt.",
  },
];
